import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import "./StepOne.css";
import { useEventType } from "../../../hooks/useEventType";
import { useSpendTypeActivityTypes } from "../../../hooks/useActivityType";
import { useRelationship } from "../../../hooks/useRelationship";
import { useExternalSource } from "../../../hooks/useExternalSource";
import { useCountry } from "../../../hooks/useCountry";
import { useCountryCities } from "../../../hooks/useCity";
import { useDivisionTeams } from "../../../hooks/useTeam";
import currencyData from "../../../currencies.json";
import { useUserDivisions } from "../../../hooks/useUser";
import { useOrganization } from "../../../hooks/useOrganization";
import { useCurrentUser } from "../../../hooks/useAuth";
// import { useDevisionBrands } from "../../../hooks/useBrand";
import { useTeamsBrands } from "../../../hooks/useBrand";
import { useEventTypeSpendTypes } from "../../../hooks/useSpendType";
export const StepOne = ({
  formData,
  setFormData,
  updateFormData,
  errors,
  setErrors,
}) => {
  const user = useCurrentUser();
  const [userTeam, setUserTeam] = useState(null);
  const [values, setValues] = useState({
    name: formData?.name || "",
    created_by: formData?.created_by || "",
    created_by_name: formData?.created_by_name || "",
    city_id: formData?.city_id || "",
    start_date: formData?.start_date || "",
    end_date: formData?.end_date || "",
    start_time: formData?.start_time || "",
    end_time: formData?.end_time || "",
    event_type_id: formData?.event_type_id || "",
    organization_id: formData?.organization_id || "",
    country_id: formData?.country_id || "",
    spend_type_id: formData?.spend_type_id || "",
    promo_number: formData?.promo_number || "",
    promo_approval_date: formData?.promo_approval_date || "",
    relationship_id: formData?.relationship_id || "",
    external_source_id: formData?.external_source_id || "",
    activity_type_id: formData?.activity_type_id || "",
    attached_files: formData?.attached_files || "",
    currency: formData?.currency || "",
    division_id: formData?.division_id,
    team_id: formData?.team_id || "",
  });

  const { data: eventTypeData } = useEventType();
  const { data: filteredSpendTypes } = useEventTypeSpendTypes(
    values.event_type_id
  );

  const { data: filteredActivityTypes } = useSpendTypeActivityTypes(
    values?.spend_type_id
  );
  const { data: relationshipData } = useRelationship();
  const { data: externalSourceData } = useExternalSource();
  const { data: organizationData } = useOrganization();
  const { data: countryData } = useCountry();
  const { data: filteredCities } = useCountryCities(values?.country_id);
  // const { data: filteredBrands } = useDevisionBrands(values?.division_id);
  const { data: filteredBrands } = useTeamsBrands(values?.team_id);
  const { data: filteredTeams } = useDivisionTeams(values?.division_id);
  const { data: userDivisionData } = useUserDivisions(user?.uid);

  const sortedActivityTypeData = filteredActivityTypes?.slice().sort((a, b) => {
    const numA = parseInt(a.name.match(/\d+/)?.[0] || 0, 10);
    const numB = parseInt(b.name.match(/\d+/)?.[0] || 0, 10);
    return numA - numB;
  });


  // Reusable styles for Select components
  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? "2px solid #159bd7" : "1px solid #d1d5db",
      borderRadius: "0.375rem",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(21, 155, 215, 0.2)" : "none",
      "&:hover": {
        border: "1px solid #159bd7",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#159bd7"
        : state.isFocused
        ? "#f3f4f6"
        : "white",
      color: state.isSelected ? "white" : "#374151",
      "&:hover": {
        backgroundColor: state.isSelected ? "#159bd7" : "#f3f4f6",
      },
    }),
  };

  // Effect to set user's team when component mounts
  useEffect(() => {
    if (user?.team_id && filteredTeams) {
      const userTeamData = filteredTeams.find(
        (team) => team.id === user.team_id
      );
      if (userTeamData) {
        setUserTeam(userTeamData);
        // Set the team_id in the form values
        setValues((prev) => ({
          ...prev,
          team_id: user.team_id,
        }));
        // Update parent form data
        if (setFormData) {
          setFormData((prev) => ({
            ...prev,
            team_id: user.team_id,
          }));
        }
      }
    }
  }, [user?.team_id, filteredTeams]);

  // Effect to set Saudi Arabia as default country
  useEffect(() => {
    if (countryData && !values.country_id) {
      const saudiArabia = countryData.find(
        (country) => country.name === "Saudi Arabia"
      );
      if (saudiArabia) {
        setValues((prev) => ({
          ...prev,
          country_id: saudiArabia.id,
        }));
        // Update parent form data
        if (setFormData) {
          setFormData((prev) => ({
            ...prev,
            country_id: saudiArabia.id,
          }));
        }
      }
    }
  }, [countryData, values.country_id, setFormData]);

  const handleFileChange = async (event) => {
    try {
      const file = event.target.files[0];
      setFormData((prevFormData) => ({
        ...prevFormData,
        attached_files: file,
      }));
      setValues((prev) => ({
        ...prev,
        attached_files: file,
      }));
    } catch (error) {
      console.error("Error handling file:", error);
    }
  };

  const handleFieldChange = async (e) => {
    // Handle react-select onChange events
    if (e && e.value !== undefined) {
      // This is a react-select onChange event
      const fieldName = e.name;
      const updatedValue = e.value;

      setValues((prevValues) => ({
        ...prevValues,
        [fieldName]: updatedValue,
      }));

      // Update parent form data if provided
      if (setFormData) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [fieldName]: updatedValue,
        }));
      }

      // Clear the error for this field
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }));
      return;
    }

    // Handle regular form input events
    const { name, value } = e.target;
    let updatedValue = value;

    // Handle event type selection and update allow_app_sign
    if (name === "event_type_id") {
      const selectedEventType = eventTypeData?.find(
        (event) => event.id === value
      );
      setValues((prevValues) => ({
        ...prevValues,
        [name]: updatedValue,
        allow_app_sign: selectedEventType?.allow_app_sign || false,
      }));

      // Update parent form data
      if (setFormData) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: updatedValue,
          allow_app_sign: selectedEventType?.allow_app_sign || false,
        }));
      }
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        [name]: updatedValue,
      }));

      // Update parent form data if provided
      if (setFormData) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: updatedValue,
        }));
      }
    }

    // Clear the error for this field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    // Date validation logic
    if (name === "start_date" || name === "end_date") {
      const currentValues = { ...values, [name]: updatedValue };

      if (currentValues.start_date && currentValues.end_date) {
        const startDate = new Date(currentValues.start_date);
        const endDate = new Date(currentValues.end_date);

        if (endDate < startDate) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            end_date: "End date cannot be before start date",
          }));
        } else {
          // Clear end_date error if validation passes
          setErrors((prevErrors) => ({
            ...prevErrors,
            end_date: "",
          }));
        }
      }
    }

    // Time validation logic when dates are the same
    if (name === "start_time" || name === "end_time") {
      const currentValues = { ...values, [name]: updatedValue };

      if (
        currentValues.start_date &&
        currentValues.end_date &&
        currentValues.start_time &&
        currentValues.end_time
      ) {
        const startDate = new Date(currentValues.start_date);
        const endDate = new Date(currentValues.end_date);

        // If dates are the same, check time
        if (startDate.getTime() === endDate.getTime()) {
          const startTime = currentValues.start_time;
          const endTime = currentValues.end_time;

          if (endTime < startTime) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              end_time:
                "End time cannot be before start time when dates are the same",
            }));
          } else {
            // Clear end_time error if validation passes
            setErrors((prevErrors) => ({
              ...prevErrors,
              end_time: "",
            }));
          }
        }
      }
    }
  };

  useEffect(() => {
    updateFormData({
      ...values,
    });
  }, [values]);

  useEffect(() => {
    setValues((prevValues) => ({
      ...prevValues,
      created_by: user?.uid,
      created_by_name: user?.first_name,
    }));
  }, [user]);

  const sortedCities = filteredCities
    ? [...filteredCities].sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      )
    : [];

  const sortedBrands = filteredBrands
    ? [...filteredBrands].sort((a, b) => (a.order ?? 999) - (b.order ?? 999))
    : [];

  // Sort event types alphabetically by name
  const sortedEventTypes = eventTypeData
    ? [...eventTypeData].sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      )
    : [];

  const sortedSpendTypeData = filteredSpendTypes?.slice().sort((a, b) =>
    a.name.localeCompare(b.name, undefined, {
      numeric: true,
      sensitivity: "base",
    })
  );
  
  return (
    <div className="py-6">
      <form className="space-y-6">
        <Grid container spacing={4}>
          <Grid item xs={12} md={12}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Event/Topic Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={values.name}
                onChange={handleFieldChange}
                className="w-full p-1.5 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              />
              {errors.name && (
                <p className="text-red-500 text-sm mt-2 ">{errors.name}</p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Event Type <span className="text-red-500">*</span>
              </label>
              <Select
                name="event_type_id"
                value={
                  sortedEventTypes?.find(
                    (eventType) => eventType.id === values.event_type_id
                  )
                    ? {
                        value: values.event_type_id,
                        label: sortedEventTypes.find(
                          (eventType) => eventType.id === values.event_type_id
                        )?.name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "event_type_id",
                    value: selectedOption?.value || "",
                  })
                }
                options={sortedEventTypes?.map((eventType) => ({
                  value: eventType.id,
                  label: eventType.name,
                }))}
                placeholder="Select event type..."
                isClearable
                isSearchable
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.event_type_id && (
                <p className="text-red-500 text-sm mt-2 ">
                  {errors.event_type_id}
                </p>
              )}
              {values.event_type_id && sortedEventTypes && (
                <p className="text-sm text-gray-500 mt-3">
                  {sortedEventTypes.find(
                    (type) => type.id === values.event_type_id
                  )?.description || ""}
                </p>
              )}
            </div>
          </Grid>
          {sortedEventTypes?.find(
            (eventType) =>
              eventType.id === values.event_type_id &&
              eventType.needs_organization === true
          ) && (
            <Grid item xs={12} md={6}>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Organization
                </label>
                <Select
                  name="organization_id"
                  value={
                    organizationData?.find(
                      (organization) =>
                        organization.id === values.organization_id
                    )
                      ? {
                          value: values.organization_id,
                          label: organizationData.find(
                            (organization) =>
                              organization.id === values.organization_id
                          )?.name,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleFieldChange({
                      name: "organization_id",
                      value: selectedOption?.value || "",
                    })
                  }
                  options={organizationData?.map((organization) => ({
                    value: organization.id,
                    label: organization.name,
                  }))}
                  placeholder="Select organization..."
                  isClearable
                  isSearchable
                  className="w-full"
                  classNamePrefix="select"
                  styles={selectStyles}
                />
                {errors.organization_id && (
                  <p className="text-red-500 text-sm mt-2">
                    {errors.organization_id}
                  </p>
                )}
              </div>
            </Grid>
          )}

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Promo/GPAS Number/UPI <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="promo_number"
                value={values.promo_number}
                onChange={handleFieldChange}
                className="w-full p-1.5 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              />
              {errors.promo_number && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.promo_number}
                </p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Attach approved Promo/GPAS document{" "}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                name="attached_files"
                onChange={handleFileChange}
                className="w-full p-1.5 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              />
              {errors.attached_files && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.attached_files}
                </p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Promo/GPAS Approval Date <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                name="promo_approval_date"
                onChange={handleFieldChange}
                value={values.promo_approval_date}
                className="w-full p-1.5 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              />
              {errors.promo_approval_date && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.promo_approval_date}
                </p>
              )}
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Spend Type <span className="text-red-500">*</span>
              </label>
              <Select
                name="spend_type_id"
                value={
                  sortedSpendTypeData?.find(
                    (spendType) => spendType.id === values.spend_type_id
                  )
                    ? {
                        value: values.spend_type_id,
                        label: sortedSpendTypeData.find(
                          (spendType) => spendType.id === values.spend_type_id
                        )?.name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "spend_type_id",
                    value: selectedOption?.value || "",
                  })
                }
                options={sortedSpendTypeData?.map((spendType) => ({
                  value: spendType.id,
                  label: spendType.name,
                }))}
                placeholder="Select spend type..."
                isClearable
                isSearchable
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.spend_type_id && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.spend_type_id}
                </p>
              )}
              {values.spend_type_id && sortedSpendTypeData && (
                <p className="text-sm text-gray-500 mt-3">
                  {sortedSpendTypeData.find(
                    (type) => type.id === values.spend_type_id
                  )?.description || ""}
                </p>
              )}
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Activity Type <span className="text-red-500">*</span>
              </label>
              <Select
                name="activity_type_id"
                value={
                  sortedActivityTypeData?.find(
                    (activityType) =>
                      activityType.id === values.activity_type_id
                  )
                    ? {
                        value: values.activity_type_id,
                        label: sortedActivityTypeData.find(
                          (activityType) =>
                            activityType.id === values.activity_type_id
                        )?.name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "activity_type_id",
                    value: selectedOption?.value || "",
                  })
                }
                options={sortedActivityTypeData?.map((activityType) => ({
                  value: activityType.id,
                  label: activityType.name,
                }))}
                placeholder="Select activity type..."
                isClearable
                isSearchable
                isDisabled={values.spend_type_id === ""}
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.activity_type_id && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.activity_type_id}
                </p>
              )}
              {values.activity_type_id && sortedActivityTypeData && (
                <p className="text-sm text-gray-500 mt-3">
                  {sortedActivityTypeData.find(
                    (type) => type.id === values.activity_type_id
                  )?.description || ""}
                </p>
              )}
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Relationship for the recipient{" "}
                <span className="text-red-500">*</span>
              </label>
              <Select
                name="relationship_id"
                value={
                  relationshipData?.find(
                    (relationship) => relationship.id === values.relationship_id
                  )
                    ? {
                        value: values.relationship_id,
                        label: relationshipData.find(
                          (relationship) =>
                            relationship.id === values.relationship_id
                        )?.name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "relationship_id",
                    value: selectedOption?.value || "",
                  })
                }
                options={relationshipData?.map((relationship) => ({
                  value: relationship.id,
                  label: relationship.name,
                }))}
                placeholder="Select relationship..."
                isClearable
                isSearchable
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.relationship_id && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.relationship_id}
                </p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                External Source System/Process{" "}
                <span className="text-red-500">*</span>
              </label>
              <Select
                name="external_source_id"
                value={
                  externalSourceData?.find(
                    (externalSource) =>
                      externalSource.id === values.external_source_id
                  )
                    ? {
                        value: values.external_source_id,
                        label: externalSourceData.find(
                          (externalSource) =>
                            externalSource.id === values.external_source_id
                        )?.name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "external_source_id",
                    value: selectedOption?.value || "",
                  })
                }
                options={externalSourceData?.map((externalSource) => ({
                  value: externalSource.id,
                  label: externalSource.name,
                }))}
                placeholder="Select external source..."
                isClearable
                isSearchable
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.external_source_id && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.external_source_id}
                </p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Event Date (Start) <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                name="start_date"
                value={values.start_date}
                onChange={handleFieldChange}
                className="w-full p-1.5 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              />
              {errors.start_date && (
                <p className="text-red-500 text-sm mt-2">{errors.start_date}</p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Event Date (End) <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                name="end_date"
                value={values.end_date}
                onChange={handleFieldChange}
                className="w-full p-1.5 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              />
              {errors.end_date && (
                <p className="text-red-500 text-sm mt-2">{errors.end_date}</p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Event Time (Start) <span className="text-red-500">*</span>
              </label>
              <input
                type="time"
                name="start_time"
                value={values.start_time}
                onChange={handleFieldChange}
                className="w-full p-1.5 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              />
              {errors.start_time && (
                <p className="text-red-500 text-sm mt-2">{errors.start_time}</p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Event Time (End) <span className="text-red-500">*</span>
              </label>
              <input
                type="time"
                name="end_time"
                value={values.end_time}
                onChange={handleFieldChange}
                className="w-full p-1.5 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
              />
              {errors.end_time && (
                <p className="text-red-500 text-sm mt-2">{errors.end_time}</p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Country of Event <span className="text-red-500">*</span>
              </label>
              <Select
                name="country_id"
                value={
                  countryData?.find(
                    (country) => country.id === values.country_id
                  )
                    ? {
                        value: values.country_id,
                        label: countryData.find(
                          (country) => country.id === values.country_id
                        )?.name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "country_id",
                    value: selectedOption?.value || "",
                  })
                }
                options={countryData?.map((country) => ({
                  value: country.id,
                  label: country.name,
                }))}
                placeholder="Select country..."
                isClearable
                isSearchable
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.country_id && (
                <p className="text-red-500 text-sm mt-2">{errors.country_id}</p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Event City <span className="text-red-500">*</span>
              </label>
              <Select
                name="city_id"
                value={
                  sortedCities?.find((city) => city.id === values.city_id)
                    ? {
                        value: values.city_id,
                        label: sortedCities.find(
                          (city) => city.id === values.city_id
                        )?.name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "city_id",
                    value: selectedOption?.value || "",
                  })
                }
                options={sortedCities?.map((city) => ({
                  value: city.id,
                  label: city.name,
                }))}
                placeholder="Select city..."
                isClearable
                isSearchable
                isDisabled={values.country_id === ""}
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.city_id && (
                <p className="text-red-500 text-sm mt-2">{errors.city_id}</p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Division <span className="text-red-500">*</span>
              </label>
              <Select
                name="division_id"
                value={
                  userDivisionData?.find(
                    (division) => division.id === values.division_id
                  )
                    ? {
                        value: values.division_id,
                        label: userDivisionData.find(
                          (division) => division.id === values.division_id
                        )?.name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "division_id",
                    value: selectedOption?.value || "",
                  })
                }
                options={userDivisionData?.map((division) => ({
                  value: division.id,
                  label: division.name,
                }))}
                placeholder="Select division..."
                isClearable
                isSearchable
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.division_id && (
                <p className="text-red-500 text-sm mt-2">
                  {errors.division_id}
                </p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Team <span className="text-red-500">*</span>
              </label>
              <Select
                name="team_id"
                value={
                  user?.team_id
                    ? userTeam
                      ? {
                          value: userTeam.id,
                          label: userTeam.name,
                        }
                      : null
                    : filteredTeams?.find((team) => team.id === values.team_id)
                    ? {
                        value: values.team_id,
                        label: filteredTeams.find(
                          (team) => team.id === values.team_id
                        )?.name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "team_id",
                    value: selectedOption?.value || "",
                  })
                }
                options={
                  user?.team_id
                    ? userTeam
                      ? [
                          {
                            value: userTeam.id,
                            label: userTeam.name,
                          },
                        ]
                      : []
                    : filteredTeams?.map((team) => ({
                        value: team.id,
                        label: team.name,
                      }))
                }
                placeholder="Select team..."
                isClearable
                isSearchable
                isDisabled={values.division_id === "" || user?.team_id}
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.team_id && (
                <p className="text-red-500 text-sm mt-2">{errors.team_id}</p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Brand <span className="text-red-500">*</span>
              </label>
              <Select
                name="brand_id"
                value={
                  sortedBrands?.find((brand) => brand.id === values.brand_id)
                    ? {
                        value: values.brand_id,
                        label: sortedBrands.find(
                          (brand) => brand.id === values.brand_id
                        )?.name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "brand_id",
                    value: selectedOption?.value || "",
                  })
                }
                options={sortedBrands?.map((brand) => ({
                  value: brand.id,
                  label: brand.name,
                }))}
                placeholder="Select brand..."
                isClearable
                isSearchable
                isDisabled={values.team_id === ""}
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.brand_id && (
                <p className="text-red-500 text-sm mt-2">{errors.brand_id}</p>
              )}
            </div>
          </Grid>

          <Grid item xs={12} md={6}>
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Currency <span className="text-red-500">*</span>
              </label>
              <Select
                name="currency"
                value={
                  currencyData.data?.find(
                    (currency) => currency.name === values.currency
                  )
                    ? {
                        value: values.currency,
                        label: `${
                          currencyData.data.find(
                            (currency) => currency.name === values.currency
                          )?.name
                        } (${
                          currencyData.data.find(
                            (currency) => currency.name === values.currency
                          )?.code
                        })`,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  handleFieldChange({
                    name: "currency",
                    value: selectedOption?.value || "",
                  })
                }
                options={currencyData.data?.map((currency) => ({
                  value: currency.name,
                  label: `${currency.name} (${currency.code})`,
                }))}
                placeholder="Select currency..."
                isClearable
                isSearchable
                className="w-full"
                classNamePrefix="select"
                styles={selectStyles}
              />
              {errors.currency && (
                <p className="text-red-500 text-sm mt-2">{errors.currency}</p>
              )}
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};
